@let clickable = type() != cardTypes.DEFAULT ? true : false;
@let readOnly = type() != cardTypes.DEFAULT ? true : false;
@let field = getCurrentField();
@let isDisabled = editService.loading() || disabled();

<div
    class="container-base"
    [class.flat]="type() === cardTypes.DEFAULT"
    [class.block-card]="block()"
    [class.clickable]="clickable"
    [class.editing]="isEditing()"
    [class.selected]="field.selected || selected()"
    [class.chrome-visible]="isEditing() || selected() || field.selected || showIaOptions() || showMoreMenu() || showModalCreateFavoriteField() || externalPopoverOpen() || popoverOpen() || railMenusOpen() > 0 || lookPanelOpen()"
    [class.look-panel-open]="lookPanelOpen()"
    [class.popover-open]="showIaOptions() || showMoreMenu() || externalPopoverOpen() || popoverOpen() || railMenusOpen() > 0"
    (pointerdown)="onPointerDown()"
    [style.--card-sp-t]="readOnly ? null : spacing().top"
    [style.--card-sp-r]="readOnly ? null : spacing().right"
    [style.--card-sp-b]="readOnly ? null : spacing().bottom"
    [style.--card-sp-l]="readOnly ? null : spacing().left">

    <!-- Este campo abre folha nova no PDF (atributo do campo, não um item na lista).
         Fica acima do conteúdo, na mesma leitura do traço de quebra da coluna. -->
    @if (!readOnly && startsOnNewPage()) {
        <div class="page-break-tag">
            <ra-icon icon="page-break" varColor="currentColor" [size]="11" />
            <span>{{ 'document.edit.cardBase.pageBreakTag' | translate }}</span>

            <!-- Desligar mora aqui, e não no menu ⋯: a tag é o próprio estado, então
                 tirá-la é o gesto direto. O menu fica só com o que ainda não foi feito. -->
            <button
                type="button"
                class="page-break-tag-remove"
                [attr.aria-label]="'document.edit.cardBase.removePageBreak' | translate"
                [raEditTooltip]="{ text: ('document.edit.cardBase.removePageBreak' | translate), position: 'bottom' }"
                (click)="$event.stopPropagation(); toggleStartOnNewPage()">
                <ra-icon icon="close" varColor="currentColor" [size]="8" />
            </button>
        </div>
    }

    @if (!readOnly)
    {
        <!-- Gutter à esquerda: seleção + alça de arraste, revelados no hover.
             Fica fora do fluxo para o conteúdo ler como documento contínuo. -->
        <div class="card-gutter">
            <input
                type="checkbox"
                class="selection-checkbox"
                [class.default-disabled]="isDisabled"
                [raEditTooltip]="{ text: ('document.edit.cardBase.selectField' | translate), position: 'bottom' }"
                [(ngModel)]="field.selected"
                [ngModelOptions]="{ standalone: true }"
                (click)="selectItem($event)"
            />

            <div
                cdkDragHandle
                class="drag-handle"
                [class.default-disabled]="isDisabled"
                [raEditTooltip]="{ text: ('document.edit.cardBase.dragToReorder' | translate), position: 'bottom' }">
                <ra-icon icon="menu" varColor="currentColor" [size]="16" />
            </div>
        </div>

        <!-- Rail flutuante, vertical, na margem direita. A mesma ordem em todo campo:
             1. favoritar;
             2. formato do campo (a paleta), projetado pelo card em `[card-toolbar]`; quem
                não tem formato próprio (texto: tudo na barra do topo) não projeta nada;
             3. encontrar no PDF;
             4. ⋯ com o resto (ações do campo, IA, espaçamento, organizar);
             5. lixeira, sempre vermelha e sempre por último. -->
        <div class="card-toolbar" raRailFit (click)="$event.stopPropagation()">

            <ra-square-icon
                backgroundColor="ghost"
                icon="star"
                [size]="48"
                [iconSize]="22"
                [class.default-disabled]="isDisabled"
                [ariaLabel]="'document.edit.cardBase.favoriteField' | translate"
                [raEditTooltip]="{ text: ('document.edit.cardBase.favoriteField' | translate), position: 'left' }"
                (click)="!isDisabled && showModalCreateFavoriteField.set(true)"
            />

            <ng-content select="[card-toolbar]" />

            <ra-square-icon
                backgroundColor="ghost"
                icon="search-normal"
                [size]="48"
                [iconSize]="22"
                [class.default-disabled]="isDisabled"
                [ariaLabel]="'document.edit.cardBase.locateInPreview' | translate"
                [raEditTooltip]="{ text: ('document.edit.cardBase.locateInPreview' | translate), position: 'left' }"
                (click)="!isDisabled && locateInPreview()"
            />

            <div
                class="card-more-wrapper"
                clickOutside
                [clickOutsideEnabled]="showMoreMenu()"
                (clickOutside)="showMoreMenu.set(false)">

                <ra-square-icon
                    backgroundColor="ghost"
                    [icon]="'more'"
                    [size]="48"
                    [iconSize]="22"
                    [active]="showMoreMenu()"
                    [class.default-disabled]="isDisabled"
                    [raEditTooltip]="showMoreMenu() ? null : { text: ('document.edit.cardBase.moreActions' | translate), position: 'left' }"
                    (click)="!isDisabled && toggleMoreMenu()"
                />

                <!-- O espaçamento não tem botão no rail: só o menu, que abre pelo item do ⋯ e
                     fica ancorado nele (o chip ocupa a caixa do ⋯, sem pegar clique). -->
                <spacing-chip [field]="field" [buttonless]="true" />

                @if (showMoreMenu())
                {
                    <div class="card-more-menu" raRailMenu (raRailMenuClose)="showMoreMenu.set(false)">
                        <!-- Ações do próprio campo (ex.: trocar a foto), com o nome do grupo. -->
                        @if (dynamicActions().length > 0) {
                            @if (overflowTitle()) {
                                <p class="card-menu-title">{{ overflowTitle() }}</p>
                            }
                            @for (item of dynamicActions(); track item.id)
                            {
                                <button
                                    type="button"
                                    class="card-menu-item"
                                    (click)="showMoreMenu.set(false); item.action()">
                                    <ra-icon [icon]="item.icon" varColor="currentColor" [size]="16" />
                                    <span class="ra-label-s">{{ item.tooltip }}</span>
                                </button>
                            }
                            <span class="card-menu-divider"></span>
                        }

                        <!-- Ajustar: IA (só em campo com texto corrido) e espaçamento. -->
                        <p class="card-menu-title">{{ 'document.edit.cardBase.menuAdjust' | translate }}</p>

                        @if (showAi() && textZone()) {
                            <button
                                type="button"
                                class="card-menu-item"
                                (click)="openIaFromMenu()">
                                <ra-icon icon="magicpen" varColor="currentColor" [size]="16" />
                                <span class="ra-label-s">{{ 'document.edit.cardBase.useAi' | translate }}</span>
                            </button>
                        }

                        <button
                            type="button"
                            class="card-menu-item"
                            (click)="openSpacingFromMenu()">
                            <ra-icon icon="item-spacing" varColor="currentColor" [size]="16" />
                            <span class="ra-label-s">{{ 'document.edit.spacing.title' | translate }}</span>
                        </button>

                        <span class="card-menu-divider"></span>

                        <!-- "Criar campo acima/abaixo" saiu: a linha "+ Inserir campo" entre os
                             itens (hover na divisa) é o jeito de criar campo no meio da folha. -->
                        <p class="card-menu-title">{{ 'document.edit.cardBase.menuOrganize' | translate }}</p>

                        <!-- Duplicar: a cópia entra logo abaixo, com a mídia clonada. -->
                        @if (canDuplicate()) {
                            <button
                                type="button"
                                class="card-menu-item"
                                (click)="showMoreMenu.set(false); duplicateField()">
                                <ra-icon icon="copy" varColor="currentColor" [size]="16" />
                                <span class="ra-label-s">{{ 'document.edit.cardBase.duplicateField' | translate }}</span>
                            </button>
                        }

                        <!-- Começar em folha nova: só o que falta fazer. Quando já está ligado,
                             quem desliga é o "x" da própria tag, no topo do card. -->
                        @if (canStartOnNewPage() && !startsOnNewPage()) {
                            <button
                                type="button"
                                class="card-menu-item"
                                (click)="showMoreMenu.set(false); toggleStartOnNewPage()">
                                <ra-icon icon="page-break" varColor="currentColor" [size]="16" />
                                <span class="ra-label-s">{{ 'document.edit.cardBase.startOnNewPage' | translate }}</span>
                            </button>
                        }

                    </div>
                }
            </div>

            <!-- Lixeira sempre à mão, no pé do rail, e sempre vermelha. Pede confirmação antes
                 de remover. -->
            <ra-square-icon
                backgroundColor="ghost"
                icon="trash"
                type="danger"
                [size]="48"
                [iconSize]="22"
                [class.default-disabled]="isDisabled"
                [ariaLabel]="'document.edit.cardBase.removeField' | translate"
                [raEditTooltip]="{ text: ('document.edit.cardBase.removeField' | translate), position: 'left' }"
                (click)="!isDisabled && editItemsService.removeItem([field._id])"
            />

            <ia-options
                clickOutside
                [field]="field"
                [isHidden]="!showIaOptions()"
                [hasOriginalBackup]="showIaOptions() && hasOriginalBackup()"
                [clickOutsideEnabled]="showIaOptions()"
                (clickOutside)="showIaOptions.set(false)"
                (close)="showIaOptions.set(false)"
                (fixText)="fixText();"
                (useAsPrompt)="useAsPrompt();"
                (generateAutomaticDescription)="generateAutomaticDescription()"
                (restoreOriginalText)="restoreOriginalText()"
            />
        </div>
    }
    @else
    {
        <!-- Modo somente leitura (lixeira/favoritos): mantém o cabeçalho
             com o eyebrow do tipo + metadados. -->
        <div class="container-header">

            <div class="container-left">
                <ra-icon [icon]="typeIconDefault()" varColor="currentColor" [size]="14" />

                @let sessionName = type() == cardTypes.TRASH ? trashField().sessionName : '';
                @let fieldTypeName = field | cardTypeFormat | translate;
                @let fieldSize = field.size | fileSizeParts:'GB';

                <p>
                    <span> {{ sessionName ? sessionName + ' - ' : '' }} {{ fieldTypeName }} - <ra-count-up [to]="fieldSize.value" [decimals]="2" [duration]="1" />&nbsp;{{ fieldSize.unit }}</span>

                    @if (type() == 'favorite')
                    {
                        <span>{{ ' - ' + favoriteField()?.description }}</span>
                    }
                </p>
            </div>

            @if (type() == cardTypes.TRASH)
            {
                <div class="container-right">
                    <p class="ra-flex-center-between gap-4 ra-label-s content-secondary">
                        <span class="color-accent-red">{{ 'document.edit.cardBase.removedOn' | translate }}</span>
                        <span class="color-accent-red">{{ trashField().dateToDelete| date: 'shortDate' }}</span>
                    </p>
                </div>
            }
        </div>
    }

    <ng-content></ng-content>
</div>

@if (showModalCreateFavoriteField()) {
    <modal-create-favorite-field
        [fieldId]="field._id"
        (close)="showModalCreateFavoriteField.set(false)"
    />
}
